<ng-container [ngTemplateOutlet]="supHeader"></ng-container>

<div class="back">
  <ng-container [ngTemplateOutlet]="header"></ng-container>
</div>

<ng-container [ngTemplateOutlet]="subHeader"></ng-container>

<p class="mb15 mt20" *ngIf="['editor', 'builder', 'ssh'].includes(mode)"><b>You will receive 7 Days of the plan of your
  choice.</b></p>

<!--<div class="db-black-offer-banner mb24">
  <p>Black Friday Special: <span>+30% off first payment</span></p>
</div>-->
<ng-container
  [ngTemplateOutlet]="mode !== 'editor' && mode !== 'builder' && mode !== 'ssh' ? newPoints : oldPoints"></ng-container>

<ng-template #oldPoints>
  <ul class="points {{mode}}">
    <li *ngFor="let point of points">
      <i class="db-icon db-icon-ds-checkmark-small"></i>
      <div>
        <p><b [innerHTML]="point.title"></b></p>
        <p *ngIf="point.desc" [innerHTML]="point.desc"></p>
        <ul *ngIf="point.subPoints" class="sub-points">
          <li *ngFor="let subPoint of point.subPoints">
            <p [innerHTML]="subPoint"></p>
          </li>
        </ul>
      </div>
    </li>
    <li [ngClass]="{'mt15': !!isAgency, 'mt50': !isAgency}">
      <div class="cancel-anytime">
        <p><b>Cancel Anytime</b></p>
        <p class="mt4">We will send you a reminder email 24 hours before the end<br/> of the period.</p>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #newPoints>
  <ul class="new-points {{mode}}">
    <li *ngFor="let point of points">
      <div>
        <p><b [innerHTML]="point.title"></b></p>
        <p *ngIf="point.desc" [innerHTML]="point.desc"></p>
        <ul *ngIf="point.subPoints" class="sub-points">
          <li *ngFor="let subPoint of point.subPoints">
            <span class="db-icon-wrap">
              <i class="db-icon db-icon-ds-checkmark-small"></i>
            </span>
            <p [innerHTML]="subPoint"></p>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <div class="cancel-anytime"
       [ngClass]="{'mt15': ['editor', 'builder', 'ssh'].includes(mode) && !!isAgency, 'mt50': ['editor', 'builder', 'ssh'].includes(mode) && !isAgency}">
    <p><b>Cancel Anytime.</b> We will send you a reminder email 24 hours<br/>before the end of the period.</p>
  </div>
</ng-template>
<div *ngIf="mode === 'editor' && isAgency && isMobile" class="db-one-mount-free-features__offer-card mt20">
  <div>
    <h3 class="mb15">Do You Want to Use Builder with Your Hosting?</h3>
    <p><b>Builder Plan</b></p>
    <p>
      Create unlimited websites with our<br> AI Builder and templates on any hosting provider.
    </p>
    <div><a [routerLink]="['/checkout']" [queryParams]="{'subscr_id': 317}"
            (click)="onClose.emit()">Buy Now</a></div>
  </div>
</div>
<!--<div *ngIf="mode === 'editor' && !isAgency && isMobile" class="db-one-mount-free-features__offer-card mt20">
  <div>
    <p><b>Hire 10Web Experts to Develop<br> and Maintain Your Website</b></p>
    <p>
      Focus on your business growth & leave the technical parts to WordPress experts with years of experience.
    </p>
    <div><a (click)="onStepChange.emit('experts')">Hire an Expert</a></div>
  </div>
</div>-->
<div class="{{(mode === 'editor' && !isAgency) ? 'mb20 mt20' : 'mb30 mt30'}}">
  <button class="ds-btn-purple-blue rectangle" [ngClass]="{'ds-btn-l': !!isMobile, 'ds-btn-xl': !isMobile}"
          (click)="onStepChange.emit('plans'); resizeToNormal()">
    <span>{{ ((['editor', 'builder', 'ssh'].includes(mode) ? 'Get' : 'Try') + ' 10Web Free for 7 days') | lowerCaseSpecificWords }}</span>
  </button>
</div>
<!--<div *ngIf="mode === 'editor' && !isAgency && !isMobile" class="db-one-mount-free-features__offer-card mt70">
  <div>
    <p><b>Hire 10Web Experts to Develop and Maintain Your Website</b></p>
    <p>
      Focus on your business growth & leave the technical parts to WordPress experts with years of experience.
    </p>
    <div><a (click)="onStepChange.emit('experts')">Hire an Expert</a></div>
  </div>
</div>-->

<ng-template #supHeader>
  <ng-container [ngSwitch]="mode">
    <p *ngSwitchCase="'creation'" class="subheader mb2">You exceeded the limit of hosted sites</p>
    <p *ngSwitchCase="'feature'" class="subheader semibold mb2">This is a pro feature</p>
    <p *ngSwitchCase="'wp-admin'" class="subheader mb2">WordPress admin is available in 10Web Pro</p>
    <p *ngSwitchCase="'builder'" class="subheader mb2">You’ve reached the limit of AI Builder pages</p>
  </ng-container>
</ng-template>

<ng-template #header>
  <ng-container [ngSwitch]="mode">
    <h2 *ngSwitchCase="'builder'">Get 7 days free of 10Web pro plans<br/> to create more pages</h2>
    <h2 *ngSwitchCase="'ssh'">Get Access to SFTP & SSH</h2>
    <h2 *ngSwitchCase="'editor'">Use Drag & Drop Editor<br class=ds-hide-desktop> Based on<br class=ds-hide-mobile>
      Elementor<br class=ds-hide-desktop> with 10Web Pro Plans for Free</h2>
    <h2 *ngSwitchDefault>Try 10Web Pro for free for 7 days</h2>
  </ng-container>
</ng-template>

<ng-template #subHeader>
  <!--<p *ngIf="mode === 'optimize'">Optimize website frontend and backend speed, add more websites and explore 10Web’s
    premium features for free.</p>-->
  <p *ngIf="mode === 'ssh'" class="desc mt4 mb20">For security reasons this feature is only available to paid users. To
    access SFTP & SSH please make a payment.</p>
  <!--<p
    *ngIf="mode !== 'creation' && mode !== 'editor' && mode !== 'optimize' && mode !== 'wp-admin' && mode !== 'builder' && mode !== 'ssh'">
    Explore all 10Web premium features, create & migrate multiple websites.</p>-->
  <p class="desc mt4 mb20"
     *ngIf="!['editor', 'builder', 'ssh'].includes(mode)">
    Build, host & optimize websites with 10Web Premium features.</p>
</ng-template>
